import { createLocaleTextHook } from '@moonpig/web-core-locale-text'

export const useLocaleText = createLocaleTextHook({
  dictionary: {
    'more_like_this.title': {
      'en-GB': 'More like this',
      'nl-NL': 'Meer zoals dit',
    },
    'more_like_this.tab_more_like_this': {
      'en-GB': 'More like this',
      'nl-NL': 'Meer zoals dit',
    },
    'more_like_this.tab_same_range': {
      'en-GB': 'More from this range',
      'nl-NL': 'Meer uit deze collectie',
    },
    'more_like_this.tab_people_also_viewed': {
      'en-GB': 'People also viewed',
      'nl-NL': 'Anderen bekeken ook',
    },
    'more_like_this.carousel_label': {
      'en-GB': 'Carousel of similar cards',
      'nl-NL': 'Carrousel met vergelijkbare kaarten',
    },
    'more_like_this.close_button_label': {
      'en-GB': 'Close similar cards',
      'nl-NL': 'Vergelijkbare kaarten sluiten',
    },
    'more_like_this.zero_results_title': {
      'en-GB': 'Unable to load similar cards',
      'nl-NL': 'Kan vergelijkbare kaarten niet laden',
    },
    'more_like_this.zero_results_description': {
      'en-GB':
        'We were unable to find cards that are similar to this card due to a technical issue. Try a different product or try again later.',
      'nl-NL':
        'We konden geen kaarten vinden die op deze kaart lijken vanwege een technisch probleem. Probeer een ander product of probeer het later opnieuw.',
    },
    'more_like_this.zero_results_close_button_label': {
      'en-GB': 'Close',
      'nl-NL': 'Sluiten',
    },
  },
})
